export default __webpack_public_path__ + "static/media/tasks-blue.3bde051f.svg";